
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_11017_23256)"}},[_c('path',{attrs:{"d":"M2.083 18.75a2.083 2.083 0 100-4.167 2.083 2.083 0 000 4.167z","fill":"#176CD8"}}),_c('path',{attrs:{"d":"M17.917 5.417a2.083 2.083 0 100-4.167 2.083 2.083 0 000 4.167z","fill":"#0051B8"}}),_c('path',{attrs:{"d":"M17.083 12.084v.416c0 .459.375.834.834.834a.836.836 0 00.833-.834v-.416A3.756 3.756 0 0015 8.334H3.75a2.084 2.084 0 010-4.167h8.108l-1.075 1.075a.83.83 0 000 1.175.805.805 0 00.592.241.854.854 0 00.592-.241l1.641-1.642a2.002 2.002 0 000-2.833L11.9.242a.83.83 0 10-1.175 1.175L11.8 2.492H3.75A3.768 3.768 0 000 6.25 3.756 3.756 0 003.75 10H15c1.15 0 2.083.934 2.083 2.084z","fill":"#12ACF2"}}),_c('path',{attrs:{"d":"M17.917 18.75a2.083 2.083 0 100-4.167 2.083 2.083 0 000 4.167z","fill":"#2C8DFF"}}),_c('path',{attrs:{"d":"M11.9 13.575a.83.83 0 10-1.175 1.175l1.075 1.075H6.667a.836.836 0 00-.834.833c0 .459.375.834.834.834h5.191l-1.075 1.075a.83.83 0 00.592 1.416.854.854 0 00.592-.241l1.641-1.642a2.012 2.012 0 000-2.842l-1.7-1.7-.008.017z","fill":"#12ACF2"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_11017_23256"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    